import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'arrows',
    template: `
        <div *ngIf="showPrev" class="eva-3-nav-slider {{size || '-md'}} -white -left -eva-3-shadow-line-hover" 
            [ngClass]="{'-inner-container': innerContainer}" (click)="prevAction.emit()">
            <i class="nav-slider-icon eva-3-icon-chevron-left"></i>
        </div>

        <div *ngIf="showNext" class="eva-3-nav-slider {{size || '-md'}} -white -right -eva-3-shadow-line-hover" 
            [ngClass]="{'-inner-container': innerContainer}" (click)="nextAction.emit()">
            <i class="nav-slider-icon eva-3-icon-chevron-right"></i>
        </div>
    `,
    styleUrls: ['./arrows.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ArrowsComponent {
    @Output() prevAction = new EventEmitter<any>();
    @Output() nextAction = new EventEmitter<any>();

    @Input() showPrev: boolean;
    @Input() showNext: boolean;
    @Input() size: string | undefined;
    @Input() innerContainer: boolean | undefined;
}
